import styled from "styled-components";

const SettingsOptionsWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export default SettingsOptionsWrapper;
